import { Outlet } from 'react-router-dom';

/**
 * Layout wrapper for the primary routes. The persistent bottom navigation was
 * removed — Home is the central hub and every subpage has an explicit Back
 * control — so this simply renders the active screen.
 */
export function TabLayout(): JSX.Element {
  return <Outlet />;
}
